<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app id="inspire">
    <div>
      <v-navigation-drawer class="no-print" app fixed v-model="drawer">
        <v-list dense>
          <v-list-tile to="/app/main" :avatar="true" exact>
            <v-list-tile-action>
              <v-icon>home</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Strona główna</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-group
            prepend-icon="assessment"
            v-if="
              roles.isAdministrator() ||
              roles.isLocalAdministrator() ||
              roles.isDepartmentEmployee() ||
              roles.isAgencyEmployee() ||
              roles.isExpert()
            "
            :value="false"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>Konkursy</v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile to="/app/contest/list">
              <v-icon style="margin-right: 10px">list</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Lista</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!--Moje oceny-->
            <v-list-tile
              to="/app/evaluations/formal"
              v-if="!roles.isExpert() && !roles.isAgencyEmployee() && !roles.isAdministrator() && !roles.isDepartmentEmployee()"
            >
              <v-icon style="margin-right: 10px">done_all</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Moje oceny</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
                        <v-list-tile to="/app/evaluations/expert" v-if="roles.isExpert() || roles.isAdministrator() || roles.isDepartmentEmployee()">
              <v-icon>done_all</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Moje oceny</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/user-projects"
              v-if="
                roles.isAdministrator() ||
                roles.isLocalAdministrator() ||
                roles.isDepartmentEmployee()
              "
            >
              <v-icon>business</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Moje projekty</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/evaluations/agency"
              v-if="roles.isAgencyEmployee()"
            >
              <v-icon>done_all</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Moje oceny</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile
            to="/app/contest/list"
            v-if="roles.isBidder() || roles.isSubBidder()"
          >
            <v-list-tile-action>
              <v-icon>assessment</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Konkursy</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            to="/app/all-offer-list"
            v-if="
              roles.isAdministrator() ||
              roles.isLocalAdministrator() ||
              roles.isDepartmentEmployee()
            "
          >
            <v-list-tile-action>
              <v-icon>mail</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Oferty</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            to="/app/bidder-offers"
            v-if="roles.isBidder() || roles.isSubBidder()"
          >
            <v-list-tile-action>
              <v-icon>mail</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Moje oferty</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            to="/app/all-projects"
            v-if="
              roles.isAdministrator() ||
              roles.isLocalAdministrator() ||
              roles.isDepartmentEmployee()
            "
          >
            <v-list-tile-action>
              <v-icon>business</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Projekty oferentów</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            to="/app/all-projects-by-agency-country"
            v-if="roles.isAgencyEmployee()"
          >
            <v-list-tile-action>
              <v-icon>business</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Projekty oferentów</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="'/app/project/bidder-project-list/' + userId"
            v-if="roles.isBidder() || roles.isSubBidder()"
          >
            <v-list-tile-action>
              <v-icon style="margin-right: 10px">business</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Moje projekty</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-group
            prepend-icon="view_list"
            v-if="
              roles.isAdministrator() ||
              roles.isLocalAdministrator() ||
              roles.isDepartmentEmployee() ||
              roles.isExpert()
            "
            :value="false"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>Nabory</v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile to="/app/agency-contest/list">
              <v-icon style="margin-right: 10px">list</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Lista</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!--Moje oceny-->
            <v-list-tile
              to="/app/agency-evaluations/substantive"
              v-if="
                roles.isLocalAdministrator()
              "
            >
              <v-icon style="margin-right: 10px">done_all</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Moje oceny</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/agency-evaluations/expert"
              v-if="roles.isExpert() || roles.isAdministrator() || roles.isDepartmentEmployee()"
            >
              <v-icon>done_all</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Moje oceny</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/user-supervised-agency-projects"
              v-if="
                roles.isAdministrator() ||
                roles.isLocalAdministrator() ||
                roles.isDepartmentEmployee()
              "
            >
              <v-icon>business</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Moje projekty</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile
            to="/app/agency-contest/list"
            v-if="roles.isAgencyEmployee()"
          >
            <v-list-tile-action>
              <v-icon>view_list</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Nabory</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            :to="{ name: 'agencyProjects' }"
            v-if="
              roles.isAdministrator() ||
              roles.isLocalAdministrator() ||
              roles.isDepartmentEmployee()
            "
          >
            <v-list-tile-action>
              <v-icon>mail</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Wnioski placówek</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            to="/app/all-agency-offers"
            v-if="roles.isAgencyEmployee()"
          >
            <v-list-tile-action>
              <v-icon>mail</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Wnioski placówki</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :to="{ name: 'agencySubmittedProjects' }"
            v-if="
              roles.isAdministrator() ||
              roles.isLocalAdministrator() ||
              roles.isDepartmentEmployee()
            "
          >
            <v-list-tile-action>
              <v-icon>business</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Projekty placówek</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            to="/app/approved-agency-projects"
            v-if="roles.isAgencyEmployee()"
          >
            <v-list-tile-action>
              <v-icon>business</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Projekty placówki</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-group
            prepend-icon="screen_share"
            v-if="
              roles.isExpert() ||
              roles.isDepartmentEmployee() ||
              roles.isInstitutionEmployee() ||
              roles.isAgencyEmployee() ||
              roles.isViewer()
            "
            :value="false"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>Udostępnione do wglądu</v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile to="/app/offer-allowances">
              <v-icon style="margin-right: 10px">mail</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Oferty</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/app/project-allowances">
              <v-icon style="margin-right: 10px">mail</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Projekty</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/app/report-allowances">
              <v-icon style="margin-right: 10px">mail</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Sprawozdania z konkursów</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/app/agency-project-allowances">
              <v-icon style="margin-right: 10px">mail</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Wnioski/Projekty placówek</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/app/agency-report-allowances">
              <v-icon style="margin-right: 10px">mail</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Sprawozdania z naborów</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>

          <v-list-tile
            @click="loadNotificationGroupsView(department.id)"
            v-if="roles.isDepartmentEmployee()"
          >
            <v-list-tile-action>
              <v-icon>supervised_user_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Komunikaty grupowe</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <!--Raporty wolontariusza-->
          <v-list-tile to="/app/report" v-if="roles.isVolunteer()">
            <v-list-tile-action>
              <v-icon>assignment</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Raporty</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile to="/app/volunteer-projects" v-if="roles.isVolunteer()">
            <v-list-tile-action>
              <v-icon>business</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Moje projekty</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            to="/app/sub-bidders"
            v-if="roles.isBidder() || roles.isSubBidder()"
          >
            <v-list-tile-action>
              <v-icon>people</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Subkonta</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            to="/app/volunteers"
            v-if="
              roles.isBidder() ||
              roles.isSubBidder() ||
              roles.isAdministrator() ||
              roles.isLocalAdministrator()
            "
          >
            <v-list-tile-action>
              <v-icon>people</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Wolontariusze</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile to="/app/users" v-if="roles.isDepartmentEmployee()">
            <v-list-tile-action>
              <v-icon>supervised_user_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Użytkownicy</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile to="/app/bidders" v-if="roles.isDepartmentEmployee()">
            <v-list-tile-action>
              <v-icon>supervised_user_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Oferenci</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-group
            prepend-icon="settings"
            v-if="roles.isAdministrator() || roles.isLocalAdministrator()"
            :value="false"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>Administracja</v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile
              to="/app/settings/library"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">library_books</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Biblioteka</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/settings/paragraphs"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">gavel</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Paragrafy</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/settings/legal-forms"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">business_center</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Formy prawne</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/settings/activity-types"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">local_activity</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Rodzaje działalności</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/settings/currencies"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">monetization_on</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Waluty</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/settings/accreditation-countries"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">map</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Kraje</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/app/agencies" v-if="roles.isAdministrator()">
              <v-icon style="margin-right: 10px">location_city</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Placówki</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/app/departments" v-if="roles.isAdministrator()">
              <v-icon style="margin-right: 10px">location_city</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Departamenty</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/app/users">
              <v-icon style="margin-right: 10px">supervised_user_circle</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Użytkownicy</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/app/bidders">
              <v-icon style="margin-right: 10px">supervised_user_circle</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Oferenci</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/app/unconfirmed-users">
              <v-icon style="margin-right: 10px">supervised_user_circle</v-icon>
              <v-list-tile-content>
                <v-list-tile-title
                  >Niepotwierdzeni użytkownicy</v-list-tile-title
                >
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/realization-years"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">date_range</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Lata realizacji projektów</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/settings/volunteer-languages"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">language</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Języki wolontariuszy</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/settings/dac-codes"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">donut_large</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Kody DAC</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              to="/app/settings/agency-project-types"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">donut_large</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Typy projektów w naborach</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!--Powiadomienia systemowe-->
            <v-list-tile
              @click="loadEmailContentView"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">mail_outline</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Powiadomienia systemowe</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!--Poprawienie błędów systemu-->
            <v-list-tile
              @click="loadSystemFixView"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">build</v-icon>
              <v-list-tile-content>
                <v-list-tile-title
                  >Naprawienie błędów systemu</v-list-tile-title
                >
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              to="/app/audit-log"
              v-if="roles.isAdministrator()"
            >
              <v-icon style="margin-right: 10px">build</v-icon>
              <v-list-tile-content>
                <v-list-tile-title
                  >Audyt systemu</v-list-tile-title
                >
              </v-list-tile-content>
            </v-list-tile>

            <!--Komunikaty grupowe-->
            <v-list-tile
              @click="loadNotificationGroupsView(department.id)"
              v-if="roles.isLocalAdministrator()"
            >
              <v-icon style="margin-right: 10px">supervised_user_circle</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Komunikaty grupowe</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-group
              sub-group
              v-if="roles.isAdministrator()"
              class="message-groups"
            >
              <v-list-tile slot="activator">
                <v-icon style="margin-right: 10px"
                  >supervised_user_circle</v-icon
                >
                <v-list-tile-title>Komunikaty grupowe</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="loadNotificationGroupsView(item.id)"
                v-bind:key="item.id"
                v-for="item in departments"
                class="mt-1"
              >
                <v-list-tile-content>{{ item.name }}</v-list-tile-content>
              </v-list-tile>
            </v-list-group>
            <!--Szablony umów-->
            <v-list-tile
              @click="loadContractTemplatesView(department.id)"
              v-if="roles.isLocalAdministrator()"
            >
              <v-icon style="margin-right: 10px">texture</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Szablony umów</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-group sub-group v-if="roles.isAdministrator()">
              <v-list-tile class="mt-2" slot="activator">
                <v-icon style="margin-right: 10px">texture</v-icon>
                <v-list-tile-title>Szablony umów</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="loadContractTemplatesView(item.id)"
                v-bind:key="item.id"
                v-for="item in departments"
              >
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list-group>
            <!--Szablony kart umów dotacji-->
            <v-list-tile
              @click="loadDonationContractTemplatesView(department.id)"
              v-if="roles.isLocalAdministrator()"
            >
              <v-icon style="margin-right: 10px">texture</v-icon>
              <v-list-tile-content>
                <v-list-tile-title
                  >Szablony kart umów dotacji</v-list-tile-title
                >
              </v-list-tile-content>
            </v-list-tile>
            <v-list-group sub-group v-if="roles.isAdministrator()">
              <v-list-tile slot="activator">
                <v-icon style="margin-right: 10px">texture</v-icon>
                <v-list-tile-title
                  >Szablony kart umów dotacji</v-list-tile-title
                >
              </v-list-tile>
              <v-list-tile
                @click="loadDonationContractTemplatesView(item.id)"
                v-bind:key="item.id"
                v-for="item in departments"
              >
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list-group>
            <!--Szablony pism-->
            <v-list-tile
              @click="loadCorrespondenceTemplatesView(department.id)"
              v-if="roles.isLocalAdministrator()"
            >
              <v-icon style="margin-right: 10px">texture</v-icon>
              <v-list-tile-title>
                <v-list-tile-title>Szablony pism</v-list-tile-title>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-group sub-group v-if="roles.isAdministrator()">
              <v-list-tile slot="activator">
                <v-icon style="margin-right: 10px">texture</v-icon>
                <v-list-tile-title>Szablony pism</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="loadCorrespondenceTemplatesView(item.id)"
                v-bind:key="item.id"
                v-for="item in departments"
              >
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list-group>
            <!--Szablony sprawozdań końcowych w konkursach-->
            <v-list-tile
              @click="loadContestReportTemplatesView(department.id)"
              v-if="roles.isLocalAdministrator() && false"
            >
              <v-icon style="margin-right: 10px">texture</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Sprawozdania w konkursach</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-group sub-group v-if="roles.isAdministrator() && false">
              <v-list-tile slot="activator">
                <v-icon style="margin-right: 10px">texture</v-icon>
                <v-list-tile-title>Sprawozdania w konkursach</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="loadContestReportTemplatesView(item.id)"
                v-bind:key="item.id"
                v-for="item in departments"
              >
                <v-list-tile-content>{{ item.name }}</v-list-tile-content>
              </v-list-tile>
            </v-list-group>
            <!--Szablony sprawozdań końcowych w naborach-->
            <v-list-tile
              @click="loadAgencyContestReportTemplatesView(department.id)"
              v-if="roles.isLocalAdministrator() && false"
            >
              <v-icon style="margin-right: 10px">texture</v-icon>
              <v-list-tile-content>
                <v-list-tile-title>Sprawozdania w naborach</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-group sub-group v-if="roles.isAdministrator() && false">
              <v-list-tile slot="activator">
                <v-icon style="margin-right: 10px">texture</v-icon>
                <v-list-tile-title>Sprawozdania w naborach</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="loadAgencyContestReportTemplatesView(item.id)"
                v-bind:key="item.id"
                v-for="item in departments"
              >
                <v-list-tile-content>{{ item.name }}</v-list-tile-content>
              </v-list-tile>
            </v-list-group>
          </v-list-group>
          <v-list-tile
            to="/app/library"
            v-if="
              roles.isLocalAdministrator() ||
              roles.isDepartmentEmployee() ||
              roles.isAgencyEmployee() ||
              roles.isExpert() ||
              roles.isBidder() ||
              roles.isSubBidder() ||
              roles.isVolunteer() ||
              roles.isViewer()
            "
          >
            <v-list-tile-action>
              <v-icon>library_books</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Biblioteka</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar app fixed class="no-print navigation-top" id="nav-top">
        <v-toolbar-side-icon
          @click.stop="drawer = !drawer"
        ></v-toolbar-side-icon>
        <v-spacer></v-spacer>
        <AccessibilityToolbar />
        <v-spacer></v-spacer>
        <v-menu class="main-menu-toolbar" offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn color="#0052A5" flat v-on="on" class="user-name">
              <div class="looged-view-name">
                <v-icon class="mr-2">assignment_ind</v-icon>{{ fullName }}
                <template
                  v-if="
                    roles.isLocalAdministrator() || roles.isDepartmentEmployee()
                  "
                >
                  <br />
                  <span style="font-size: 12px">{{ department.name }}</span>
                </template>
                <template v-else-if="roles.isAgencyEmployee()">
                  <br />
                  <span style="font-size: 12px">{{ agency.name }}</span>
                </template>
                <template v-else-if="roles.isBidder() || roles.isSubBidder()">
                  <br />
                  <span style="font-size: 12px">{{ bidderName }}</span>
                </template>
              </div>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile>
              <v-icon class="mr-2">assignment_ind</v-icon>
              {{ fullName }} ({{ systemRole }})
            </v-list-tile>
            <v-list-tile @click="openProfile">
              <v-icon class="mr-2">account_circle</v-icon>Mój profil
            </v-list-tile>
            <v-list-tile @click="resetEmailDialog = true">
              <v-icon class="mr-2">mail</v-icon>Zmień e-mail / login
            </v-list-tile>
            <v-list-tile @click="resetPasswordDialog = true">
              <v-icon class="mr-2">lock</v-icon>Zmień hasło
            </v-list-tile>
            <v-list-tile
              v-if="roles.isVolunteer() && !accountRemovalRequested"
              @click="requestAccountRemoval"
            >
              <v-icon class="mr-2">warning</v-icon>Zgłoś prośbę o usunięcie
              konta
            </v-list-tile>
            <v-list-tile
              v-if="roles.isVolunteer() && accountRemovalRequested"
              @click="cancelAccountRemovalRequest"
            >
              <v-icon class="mr-2">warning</v-icon>Wycofaj prośbę o usunięcie
              konta
            </v-list-tile>
          </v-list>
        </v-menu>
        <Timer />
        <v-btn @click="logout" class="button-logout">Wyloguj</v-btn>
      </v-toolbar>
      <v-content id="main">
        <div>
          <v-btn
            @click="back"
            class="hidden-xs-only no-print"
            flat
            icon
            v-show="arrow_showed"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </div>
        <router-view></router-view>
        <v-footer primary color="white" class="d-flex footer" fixed>
          <div class="my-3 regulation">
            <a href="/declaration.html"> Deklaracja dostępności </a>
          </div>
        </v-footer>
      </v-content>

      <reset-email-dialog
        v-if="resetEmailDialog"
        v-on:closeDialog="closeResetEmailDialog"
      ></reset-email-dialog>
      <reset-password-dialog
        v-if="resetPasswordDialog"
        v-on:closeDialog="closeResetPasswordDialog"
      ></reset-password-dialog>
    </div>
  </v-app>
</template>

<script>
import { Api } from "@/api";
import { User } from "@/api/generated/User";
import { Department } from "@/api/generated/Department";
import ResetEmailDialog from "./profile_settings/ResetEmailDialog";
import ResetPasswordDialog from "./profile_settings/ResetPasswordDialog";
import AccessibilityToolbar from "../../view/components/AccesibilityToolbar";
import Timer from '@/view/components/Timer';
import Vue from "vue";

export default {
  name: "LoggedView",

  components: { Timer, ResetEmailDialog, ResetPasswordDialog, AccessibilityToolbar },

  computed: {
    arrow_showed() {
      return true;
    }
  },

  data() {
    return {
      resetEmailDialog: false,
      resetPasswordDialog: false,
      drawer: null,
      userId: null,
      fullName: "",
      systemRole: "",
      agency: {
        id: null,
        name: ""
      },
      department: {
        id: null,
        name: "",
        shortName: ""
      },
      bidderName: "",
      accountRemovalRequested: false,
      departments: [],
      nameTooLong: false
    };
  },

  beforeCreate() {
    Api.get(
      this,
      "/user/user-info",
      response => {
        this.userId = response.id;
        this.fullName = response.fullName;
        this.systemRole = response.role;
        if (
          this.roles.isLocalAdministrator() ||
          this.roles.isDepartmentEmployee()
        ) {
          this.getUserDepartment();
        }
        if (this.roles.isBidder()) {
          this.getUserBidderName();
        }
        if (this.roles.isSubBidder()) {
          this.getUserSubBidderName();
        }
        if (this.roles.isAgencyEmployee()) {
          this.getUserAgency();
        }
        if (this.roles.isAdministrator()) {
          this.getDepartments();
        }
        if (this.roles.isVolunteer()) {
          this.getAccountRemovalRequestStatus();
        }
      },
      () => {
        Vue.prototype.$keycloak.login({ redirectUri: document.location.href });
      }
    );
  },

  methods: {
    async logout() {
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("role");
      Vue.prototype.$keycloak.keycloak.logout({ redirectUri: process.env.VUE_APP_APP_URL });
    },
    closeResetEmailDialog() {
      this.resetEmailDialog = false;
    },
    closeResetPasswordDialog() {
      this.resetPasswordDialog = false;
    },
    back() {
      this.$router.go(-1);
    },
    getUserDepartment() {
      User.getUserDepartment(this, response => {
        this.department = response;
      });
    },
    getUserAgency() {
      User.getUserAgency(this, response => {
        this.agency = response;
      });
    },
    getUserBidderName() {
      User.getUserBidderName(this, response => {
        this.bidderName = response.name;
      });
    },
    getUserSubBidderName() {
      User.getUserSubBidderName(this, response => {
        this.bidderName = response.name;
      });
    },
    getDepartments() {
      Department.getList(this, response => {
        this.departments = response;
      });
    },
    getAccountRemovalRequestStatus() {
      User.getAccountRemovalRequestStatus(this, response => {
        this.accountRemovalRequested = response;
      });
    },
    openProfile() {
      this.$router.push("/app/profile/" + this.userId);
    },
    loadEmailContentView() {
      this.$router.push("/app/settings/email-contents");
    },
    loadSystemFixView() {
      this.$router.push("/app/system-fix");
    },
    loadNotificationGroupsView(depId) {
      this.$router.push("/app/notification-groups/" + depId + "/list");
    },
    loadContractTemplatesView(depId) {
      this.$router.push("/app/contract-templates/" + depId);
    },
    loadDonationContractTemplatesView(depId) {
      this.$router.push("/app/donation-contract-templates/" + depId);
    },
    loadCorrespondenceTemplatesView(depId) {
      this.$router.push("/app/correspondence-templates/" + depId);
    },
    loadContestReportTemplatesView(depId) {
      this.$router.push("/app/contest-report-templates/" + depId + "/list");
    },
    loadAgencyContestReportTemplatesView(depId) {
      this.$router.push(
        "/app/agency-contest-report-templates/" + depId + "/list"
      );
    },
    requestAccountRemoval() {
      if (!this.roles.isVolunteer()) return;
      this.$confirm(
        "Czy na pewno chcesz zgłosić prośbę o usunięcie konta? Zgłoszenie zostanie przekazane do administratora.",
        {
          icon: "warning",
          title: "Usunięcie konta",
          color: "red",
          width: 500
        }
      ).then(response => {
        if (response) {
          User.putAccountRemovalRequest(
            this,
            successResponse => {
              this.accountRemovalRequested = true;
              this.$messagesBus.$emit(
                "success",
                "Zgłoszenie zostało pomyślnie wysłane",
                successResponse
              );
              sessionStorage.removeItem("access_token");
              sessionStorage.removeItem("role");
              Vue.prototype.$keycloak.login({ redirectUri: document.location.href });
            },
            errorResponse => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się wysłać zgłoszenia",
                errorResponse
              );
            }
          );
        }
      });
    },
    cancelAccountRemovalRequest() {
      if (!this.roles.isVolunteer()) return;
      this.$confirm("Czy na pewno chcesz wycofać prośbę o usunięcie konta?", {
        icon: "warning",
        title: "Wycofanie prośby o usunięcie konta",
        color: "red",
        width: 500
      }).then(response => {
        if (response) {
          User.putUndoAccountRemovalRequest(
            this,
            successResponse => {
              this.accountRemovalRequested = false;
              this.$messagesBus.$emit(
                "success",
                "Zgłoszenie zostało pomyślnie wycofane",
                successResponse
              );
            },
            errorResponse => {
              this.$messagesBus.$emit(
                "error",
                "Nie udało się wycofać zgłoszenia",
                errorResponse
              );
            }
          );
        }
      });
    }
  }
};
</script>

<style scoped>
.navigation-top {
  overflow-x: auto;
  overflow-y: hidden;
  position: sticky !important;
}

.v-list__group__items > div {
  margin-top: 10px;
}

.v-list > div {
  line-height: 24px;
  margin-top: 10px;
}

.button-logout {
  background-color: #0052a5 !important;
  color: #fff;
}

.v-list--dense .v-list__tile .v-icon {
  margin-right: 10px;
}

.v-toolbar {
  background-color: #fff !important;
}

.v-list__tile__content {
  overflow: initial;
  width: 150px;
}

.v-list__tile__title {
  white-space: normal;
  overflow: initial;
  word-break: break-word;
  max-width: 90%;
  height: auto;
}

/* Fixed IE 11 problem */
[data-v-4b942846].v-list__tile__content {
  display: inline-block;
  -ms-flex-direction: initial;
  line-height: 26px;
}
.v-list__tile__content {
  white-space: normal;
  overflow: initial;
  word-break: break-word;
  word-wrap: break-word;
}
.footer {
  z-index: 1;
}
</style>
